module.exports = __webpack_public_path__ + "static/media/standards.a772affc.svg";